import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRef, useEffect } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const P: React.FC = () => {
    const { t } = useLang('shp3.P');
    const sectionRef = useRef<HTMLDivElement>(null);
    const webpOrJpg = useWebpOrJpg('#shp3-P');
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current?.querySelector('.title');
        const ani2El = sectionRef.current?.querySelector('.ani-2');
        const ani25El = sectionRef.current?.querySelector('.ani-2-5');
        const ani3El = sectionRef.current?.querySelector('.ani-3');
        const ani35El = sectionRef.current?.querySelector('.ani-3-5');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                ani2El?.classList.add('enter');
                ani25El?.classList.add('enter');
                ani3El?.classList.add('enter');
                ani35El?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    ani2El?.classList.remove('enter');
                    ani25El?.classList.remove('enter');
                    ani3El?.classList.remove('enter');
                    ani35El?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} shp3-P GtmModuleData-section`}
                id="shp3-P"
                data-section-id={'shp3-P'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="title ani-1">{t('title')}</div>
                <div className="list">
                    <div className="item">
                        <img className="ani-2" src={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758262251253/512px-SGS_Logo.svg%201.png')} />
                        <div className="item-title ani-3">{t('item1')}</div>
                    </div>
                    <div className="item">
                        <img className="ani-2-5" src={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758262251006/Frame%201612707754.png')} />
                        <div className="item-title ani-3-5">{t('item2')}</div>
                    </div>
                </div>
            </section>
            <EcoSpace />
        </>
    );
};

export default P;
